// utils/sendSMS.js
import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";

export const sendSMS = async (phone, message) => {
  const functions = getFunctions(getApp());
  const sendSMSFn = httpsCallable(functions, "sendSMS");

  try {
    const result = await sendSMSFn({ to: phone, message: message });
    return result.data;
  } catch (err) {
    console.error("SMS send error:", err);
    return null;
  }
};
